// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Interfaces and types
import { IResMessage, TQueryParams } from 'types/appTypes';
import {
  IGetScansRes,
  IGetScanDetails,
  IUpdateScanBodyWithParams,
  IUpdateScanRes,
  IDeleteScanParams,
  IDeleteScanRes,
  ICreateScanFileRes,
} from 'types/scans';

export const getScans = (params: TQueryParams) => {
  return xhr.get<IGetScansRes, IGetScansRes>(`${ENDPOINTS.scans}`, { params });
};

export const getScanDetails = (id: number) => {
  return xhr.get<IGetScanDetails, IGetScanDetails>(`${ENDPOINTS.scans}/${id}`);
};

export const updateScanDetails = ({ id, body }: IUpdateScanBodyWithParams) => {
  return xhr.patch<IUpdateScanRes, IUpdateScanRes>(`${ENDPOINTS.scans}/${id}`, body);
};

export const deleteScanDetails = ({ id }: IDeleteScanParams) => {
  return xhr.delete<IDeleteScanRes, IDeleteScanRes>(`${ENDPOINTS.scans}/${id}`);
};

export const addScanFile = (file: FormData) => {
  return xhr.post<ICreateScanFileRes, ICreateScanFileRes>(`${ENDPOINTS.scanFiles}`, file);
};

export const deleteScanFile = (id: string) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.scanFiles}/${id}`);
};
